import React from "react"
import { createPortal } from "react-dom"
import { AnimatePresence } from "framer-motion"
import { ModalContent } from "./ModalContent"
import { GPSModalProps } from "./types"

export const GPSModal: React.FC<GPSModalProps> = (props) => {
  return createPortal(
    <AnimatePresence>
      {props.isOpen && <ModalContent key="gps-modal" {...props} />}
    </AnimatePresence>,
    document.body
  )
}

export default GPSModal